export default __webpack_public_path__ + "static/media/stats-given-recognition.2054d1e7.svg";